import {motion} from 'framer-motion';
import Card from '../../shared/Card';
import GeneralContext from '../../../context/GeneralContext';
import { useContext, useState } from 'react';
import TextInputHorizontalTag from '../../shared/TextInputHorizontalTag';
import Select from '../../shared/Select';
import ButtonFunction from '../../shared/ButtonFunction';
import { FaUserPlus } from "react-icons/fa";
import { fetchBody } from '../../../utils/fetch';

function AddUser() {

    const { changeCurrentMenu, changeModalTitle, changeModalText, changeModalType } = useContext(GeneralContext);

    const [userDocument, setUserDocument] = useState('');
    const changeUserDocument = (e) => {
        setUserDocument(e.target.value);
    }

    const [firstName, setFirstName] = useState('');
    const changeFirstName = (e) => {
        setFirstName(e.target.value);
    }

    const [lastName, setLastName] = useState('');
    const changeLastName = (e) => {
        setLastName(e.target.value);
    }

    const [password, setPassword] = useState('');
    const changePassword = (e) => {
        setPassword(e.target.value);
    }

    const [passwordConfirm, setPasswordConfirm] = useState('');
    const changePasswordConfirm = (e) => {
        setPasswordConfirm(e.target.value);
    }

    const [questions] = useState([
        {
            id: 0,
            value: '',
            text: ''
        },
        {
            id: 1,
            value: '¿En qué año se conocieron tus padres?',
            text: '¿En qué año se conocieron tus padres?'
        },
        {
            id: 2,
            value: '¿Cuál es el nombre de tu primera mascota',
            text: '¿Cuál es el nombre de tu primera mascota'
        },
        {
            id: 3,
            value: '¿En qué escuela estudiaste la primaria?',
            text: '¿En qué escuela estudiaste la primaria?'
        }
    ]);

    const [selectedQuestion, setSelectedQuestion] = useState('');
    const changeSelectedQuestion = (e) => {
        setSelectedQuestion(e.target.value);
    }

    const [answer, setAnswer] = useState('');
    const changeAnswer = (e) => {
        setAnswer(e.target.value);
    }

    const verifyAndSend = async () => {

        let alertMessage = '';

        let validDocument = true;
        if (userDocument.length < 4) {
            alertMessage = 'El documento no puede estar vacío o tener menos de cuatro caracteres\n';
            validDocument = false;
        }

        let validFirstName = true;
        if (firstName === '') {
            alertMessage = alertMessage + 'El nombre no puede estar vacío\n';
            validFirstName = false;
        }

        let validLastName = true;
        if (lastName === '') {
            alertMessage = alertMessage + 'El apellido no puede estar vacío\n';
            validLastName = false;
        }

        let validPassword = true;
        if (password === '') {
            alertMessage = alertMessage + 'La contraseña no puede estar vacía\n';
            validPassword = false;
        }

        let validPasswordConfirm = true;
        if (password !== passwordConfirm) {
            alertMessage = alertMessage + 'Las contraseñas deben coincidir\n';
            validPasswordConfirm = false;
        }

        let validQuestion = true;
        if (selectedQuestion === '') {
            alertMessage = alertMessage + 'Debe seleccionar una pregunta\n';
            validQuestion = false;
        }

        let validAnswer = true;
        if (answer === '') {
            alertMessage = alertMessage + 'La respuesta de seguridad no puede estar vacía\n';
            validAnswer = false;
        }

        if (alertMessage !== '') {
            const modal = document.getElementById("myModal");
            changeModalTitle('Error en el registro');
            changeModalText(alertMessage);
            changeModalType('alert');
            modal.style.display = "block";
        }

        if (validDocument && validFirstName && validLastName && validPassword && validPasswordConfirm && validQuestion && validAnswer) {
            
            const data = {
                first_name: firstName.trim(),
                last_name: lastName.trim(),
                document: userDocument.trim(),
                password: password.trim(),
                security_question: selectedQuestion,
                security_answer: answer.trim()
            }

            const response = await fetchBody('add/', 'POST', data);

            if (response.success) {
                const card = document.getElementById('addUserCard');
                card.style.animation = 'vanish-up 0.5s';
                card.addEventListener("animationend", function finAnimacion () {
                    card.removeEventListener("animationend", finAnimacion);
                    card.style.display = 'none';
                    changeCurrentMenu('active-users');
                });
    
            }
        }
    }

  return (
    <motion.div
        id='addUserCard'
        key='adminAddUser'
        initial={{opacity: 0, x: -1000}}
        animate={{opacity: 1, x: 0}}
        exit={{opacity: 0, x: -1000, transition:{duration: 0.5, delay: 0}}}
        transition={{duration: 0.5}}>
          <Card hasBackNavigation={true} backNavigationFunction={changeCurrentMenu} backNavigationTarget={'manage-users'}>
            <h2>Registrar Usuario</h2>
            <TextInputHorizontalTag label='Documento' inputClass='adminInput' changeEvent={changeUserDocument} />
            <TextInputHorizontalTag label='Nombre' inputClass='adminInput' changeEvent={changeFirstName} />
            <TextInputHorizontalTag label='Apellido' inputClass='adminInput' changeEvent={changeLastName} />
            <TextInputHorizontalTag label='Contraseña' type='password' inputClass='adminInput' changeEvent={changePassword} />
            <TextInputHorizontalTag label='Confirmar contraseña' type='password' inputClass='adminInput' changeEvent={changePasswordConfirm} />
            <Select options={questions} changeEvent={changeSelectedQuestion} label='Pregunta de seguridad' />
            <TextInputHorizontalTag label='Respuesta de seguridad' inputClass='adminInput' changeEvent={changeAnswer} />
            <br />
            <ButtonFunction buttonFunction={verifyAndSend} buttonClass='adminButton' ><FaUserPlus/>Registrar</ButtonFunction>
          </Card>
    </motion.div>
  )
}

export default AddUser